import {Col, Row} from "antd";
import React from "react";

function Footer() {
    return (
        <Row justify={"center"}>
            <Col>
                <h5 style={{}}>© 2024 L'Atelier de Macaron</h5>
            </Col>
        </Row>
    )
}

export default Footer;